var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "privacy-policy" }, [
    _c(
      "div",
      { staticClass: "privacy-policy__content" },
      [
        _c("title-view", { attrs: { variant: "align-left no-padding" } }, [
          _vm._v("\n      " + _vm._s(_vm.$t("privacy_policy")) + "\n    ")
        ]),
        _c(
          "div",
          { staticClass: "privacy-policy__content__text" },
          [
            _c("text-view", { attrs: { variant: "normal no-pre-line" } }, [
              _c("p", [
                _vm._v(
                  "\n          The BLISS APPLICATIONS agency undertakes to process all personal data in the context of\n          its activities and in accordance with\n          Regulation 2016/679 of the European Parliament and of the Council of 27 April 2016\n          on the protection of individuals\n          with regard to the which concerns the processing of personal data and the free movement\n          of personal data.\n        "
                )
              ]),
              _c("br"),
              _vm._v(
                "\n        To this end, BLISS APPLICATIONS commits it self to:\n        "
              ),
              _c("br"),
              _c("br"),
              _c("li", [
                _vm._v(
                  "\n          Collect only data from the holders, and only those that are strictly necessary for the\n          performance of their commercial activity and Human Resources management\n          (in the case of\n          the holders being employees\n          of BLISS APPLICATIONS);\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          Whenever legally required, collect the consent of the data subject directly and in\n          advance, obtaining authorization for use in the business environment of the company;\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          Do not share data with other entities that do not have the necessary technical and\n          organizational measures to ensure the implementation of the regulation;\n        "
                )
              ]),
              _c("br"),
              _c("p", [
                _vm._v(
                  "\n          In addition, BLISS APPLICATIONS assures holders of data that these are: (a)\n          the data subject, in accordance with the legislation\n          in force, any anomalous situation that has occurred and that poses significant risks\n          to their fundamental rights and freedoms\n        "
                )
              ]),
              _c("br"),
              _c("li", [
                _vm._v("Object of a fair, fair and transparent treatment; ")
              ]),
              _c("li", [
                _vm._v(
                  "Collected for specific, explicit and legitimate purposes; "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          Adequate, relevant and limited to what is necessary in relation to the purposes for\n          which they are processed;\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          Preserved only for the period necessary for the purposes for which they are treated;\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          Treaties in a way that guarantees their safety, including protection against their\n          unauthorized or unlawful treatment and against their accidental loss,\n          destruction or damage.\n        "
                )
              ]),
              _c("br"),
              _vm._v(
                "\n        BLISS APPLICATIONS also guarantees the following rights to data holders:\n        "
              ),
              _c("br"),
              _c("br"),
              _c("li", [
                _vm._v(
                  "\n          access to personal data collected by them and to exercise that right easily;\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          rectification, destruction or opposition to the processing of your personal data;\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          to know and be informed of the purposes for which personal data are processed,\n          the period during which the data are processed, the identity of potential\n          recipients, the rationale underlying the possible automatic processing of\n          personal data and, at least when the definition of profiles, their consequences;\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          to receive personal data concerning you in a structured, current, readable and\n          interoperable format (capable of being read and processed by any organization),\n          for transmission to another responsible party;\n        "
                )
              ]),
              _c("li", [
                _vm._v(
                  "\n          to complain to BLISS APPLICATIONS of any situation they deem to be anomalous,\n          regarding the protection of their personal data or their privacy.\n        "
                )
              ]),
              _c("br"),
              _c("br"),
              _c("p", [
                _vm._v(
                  '\n          For the exercise of rights by data subjects, as well as for other issues related\n          to the protection of personal data,\n          BLISS APPLICATIONS has designated an element of the organization to perform the\n          functions of "Data Protection Officer", whose\n          responsibility is to ensure that the technical and organizational measures necessary\n          to effectively and effectively\n          protect personal data and maintain the privacy of the holders are implemented and\n          are subject to continuous\n          improvement. The BLISS APPLICATIONS Data Protection Officer can be contacted through\n          the e-mail address\n          '
                ),
                _c(
                  "a",
                  { attrs: { href: _vm.getEmail(_vm.$t("project_11")) } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("project_11")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(".\n        ")
              ]),
              _c("br"),
              _c("p", [
                _vm._v(
                  "\n          Your requests will be treated with special care so that we can ensure the effectiveness\n          of your rights. You may be\n          asked to prove your identity so as to ensure that the personal data is shared only with\n          your cardholder. You must be\n          aware that in certain cases, under applicable law, your request can not be immediately\n          or fully satisfied. In any\n          case, it will be informed of the measures taken to that effect within one month from\n          the moment the request is made.\n          You also have the right to complain to the supervisory authority:\n          "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getLink(_vm.$t("cnpd")),
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.$t("cnpd")) + "\n          "
                    )
                  ]
                ),
                _vm._v(".\n          "),
                _c("br"),
                _c("br"),
                _vm._v(
                  "If consent is legally required for the\n          processing of personal data, the data subject has the right to withdraw consent at any\n          time, although that right\n          does not compromise the lawfulness of the treatment made on the basis of the prior\n          consent given or the subsequent\n          processing of the same data, based on another legal basis, such as compliance with the\n          contract or legal obligation\n          to which the Company is subject. If you wish to withdraw your consent, please contact\n          our Data Protection Officer,\n          through the following contact:\n          "
                ),
                _c(
                  "a",
                  { attrs: { href: _vm.getEmail(_vm.$t("project_11")) } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("project_11")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(".\n          "),
                _c("br"),
                _c("br"),
                _vm._v(
                  "If the processing of data is\n          done for the\n          purposes of direct marketing\n          you can still, at any time, oppose the treatment of your personal data. If you have any\n          questions regarding this\n          policy or other privacy issues, or if you wish to exercise any of your rights, please\n          contact us at the following\n          e-mail:\n          "
                ),
                _c(
                  "a",
                  { attrs: { href: _vm.getEmail(_vm.$t("project_11")) } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("project_11")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(".\n        ")
              ])
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b3b231b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b3b231b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/privacy-policy.vue
// module id = 598
// module chunks = 6